<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col>
        <base-items store-module="messages" @items="items = $event" @state="state = $event">
          <v-card :loading="state.loading || state.deleting">
            <v-card-title>
              <v-row align="center">
                <v-col cols="auto" class="headline">
                  Barview Messages
                </v-col>
                <v-col>
                  <v-btn color="primary" fab depressed small @click="openItemForm(createNewItem())" :disabled="state.working"><v-icon>mdi-plus</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <div class="mb-3">
                These messages are available to send to a customer via the barview when "Barview Messages" is enabled for its operator.
              </div>
              <p v-if="sortedItems.length == 0">
                No messages
              </p>
              <v-list v-else>
                <draggable v-model="sortedItems" ghost-class="tab-ghost" handle=".handle">
                  <v-list-item
                    v-for="message in sortedItems"
                    :key="message.id"
                    link
                    @click="openItemForm(message)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{message.message}}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn text icon @click.stop="deleteItem(message)" :disabled="state.deleting"><v-icon>mdi-delete</v-icon></v-btn>
                    </v-list-item-action>
                    <v-list-item-action class="handle" @click.stop="" @mousedown.stop="">
                      <v-icon>mdi-drag-horizontal-variant</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </draggable>
              </v-list>
            </v-card-text>
          </v-card>
        </base-items>
      </v-col>
    </v-row>

    <v-dialog :value="editItem" max-width="600px" persistent>
      <message-form ref="itemForm" :item="editItem" @submit="saveItem" @cancel="closeItemForm"/>
    </v-dialog>

  </v-container>
</template>

<script>
import {BaseItems} from 'dync-baseitem';
import draggable from 'vuedraggable'
import MessageForm from '../components/MessageForm.vue'

export default {
  data () {
    return {
      items: [],
      state: {},
      editItem: null
    };
  },
  computed: {
    sortedItems: {
      get () {
        var items = this.items.slice(0);
        items.sort((a, b) => (a.order || 0) - (b.order || 0));
        return items;
      },
      set (items) {
        const reorderedItems = items.map((t, i) => Object.assign({}, t, {order: i}));
        const reorderedItemsPayload = reorderedItems.map(t => ({id: t.id, order: t.order}));

        this.$store.commit('messages/replaceItems', reorderedItems);
        this.$store.dispatch('messages/updateItems', reorderedItemsPayload).then(() => {
        }).catch(() => {
          this.$store.commit('messages/replaceItems', items);
          this.$snackbar({message: 'Could not save message order.', theme: 'error'});
        });
      }
    }
  },
  methods: {
    getNextOrderNumber() {
      var lastItem = this.sortedItems[this.sortedItems.length-1];
      if (lastItem && lastItem.order != undefined) {
        return lastItem.order + 1;
      } else {
        return 1;
      }
    },
    openItemForm(item) {
      this.editItem = Object.assign({}, item);
    },
    closeItemForm () {
      this.editItem = null;
      if (this.$refs.itemForm) {
        this.$refs.itemForm.reset();
      }
    },
    createNewItem() {
      return {
        message: '',
        category: 'barview',
        order: this.getNextOrderNumber()
      };
    },
    saveItem (item) {
      var result;

      if (item.id)
        result = this.$store.dispatch('messages/updateItem', item);
      else
        result = this.$store.dispatch('messages/createItem', item);

      result.then(() => {
        this.closeItemForm();
        this.$snackbar({message: 'Message saved', theme: 'success'});
      });
    },
    deleteItem (item) {
      this.$confirm({
        title: 'Remove the message',
        message: `Are you sure you want to remove the message "${item.message}"?`
      }).then(() => {
        this.$store.dispatch('messages/deleteItem', item.id).then(() => {
          this.$snackbar({message: 'Message removed', theme: 'success'})
        }).catch((error) => {
          console.error(error);
          this.$snackbar({message: 'Could not remove the message', theme: 'error'})
        });
      });
    }
  },
  components: {
    BaseItems,
    draggable,
    MessageForm
  }
}
</script>

<style lang="scss" scoped>
.handle {
  cursor: grab;
}
</style>
